module.exports = __webpack_public_path__ + "static/media/ra.0362c8de.jpg";